import React, { useCallback, useState } from 'react';
import { GoalId, GoalsFilterType, isGoalFilterType } from './types';
import { GoalSidebar } from './GoalSidebar/GoalSidebar';
import { useGoalFilter } from './useGoalFilter';
import { GoalFilter } from './GoalsFilter/GoalsFilter';
import { GoalsListWithFilter } from './GoalsList/GoalsListWithFilter';
import { GoalPeriodSelector } from './GoalPeriodSelector/GoalPeriodSelector';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import { t } from 'i18next';

const CREATE_GOAL = 'createGoal';
const i18prefix = 'performanceReview.goals2';

type Props = {
  isManagerView?: boolean;
};

export const GoalsPage: React.FC<Props> = ({ isManagerView = false }) => {
  const [selectedGoalId, setSelectedGoalId] = useState<
    GoalId | null | 'createGoal'
  >(null);

  const [filter, setFilter] = useGoalFilter(
    isManagerView,
    !isManagerView ? 'myGoals' : 'myReportsGoals',
  );

  const handleFilterChange = useCallback(
    (filter: GoalFilter) => {
      setFilter(filter);
    },
    [setFilter],
  );

  const handleCloseSidebar = useCallback(
    () => setSelectedGoalId(null),
    [setSelectedGoalId],
  );

  const handleCreateGoal = useCallback(
    () => setSelectedGoalId(CREATE_GOAL),
    [setSelectedGoalId],
  );

  const handleGoalClick = useCallback(
    (goalId: GoalId) => {
      setSelectedGoalId(goalId);
    },
    [setSelectedGoalId],
  );

  const handleFilterTypeChange = useCallback(
    (type: string | null) => {
      if (!isGoalFilterType(type)) {
        return;
      }
      setFilter({ ...filter, filterType: type });
    },
    [filter, setFilter],
  );

  const filterTypes = getFilterTypes(isManagerView);

  // todo: fix tabs space bottom
  return (
    <>
      <Row>
        <Col>
          <GoalPeriodSelector />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <Tabs
            activeKey={filter.filterType}
            onSelect={handleFilterTypeChange}
            className="border-bottom-0">
            {filterTypes.map((filterType) => (
              <Tab
                key={filterType}
                eventKey={filterType}
                title={t(`${i18prefix}.filterType.${filterType}`)}
              />
            ))}
          </Tabs>
        </Col>
      </Row>
      <GoalsListWithFilter
        isManagerView={isManagerView}
        onCreateGoal={handleCreateGoal}
        onGoalClick={handleGoalClick}
        filter={filter}
        onFilterChange={handleFilterChange}
      />
      <GoalSidebar
        goalId={selectedGoalId !== CREATE_GOAL ? selectedGoalId : null}
        visible={selectedGoalId !== null}
        onClose={handleCloseSidebar}
      />
    </>
  );
};

const getFilterTypes = (isManager: boolean): GoalsFilterType[] => {
  if (!isManager) {
    return ['myGoals', 'colleaguesGoals', 'allGoals'];
  } else {
    return ['myReportsGoals', 'allGoals'];
  }
};
